const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  WETH_ALCX: "0xc3f279090a47e80990fe3a9c30d24cb117ef91a8"
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_ALCX]: 0
};

const POOL_ID_TO_REWARDS_ADDRESSES = {
  [PAIR_ADDRESS_TO_REWARDS_POOL[PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_ALCX]]: ["0x6b3595068778dd592e39a122f4f5a5cf09c90fe2"],
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WETH_ALCX]: 2,
};

module.exports = {
  ADDRESS: "0xef0881ec094552b2e128cf945ef17a6752b4ec5d",
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  POOL_ID_TO_REWARDS_ADDRESSES,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH
};
